import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-icon',
	templateUrl:'./WaIconPage.html',
	styles: [],
	styleUrls:['./WaIconPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaIconPage
{
	mdContent_359 = `\`\`\`java
import com.jwebmp.webawesome.components.icon.WaIcon;
\`\`\``;
	mdContent_360 = `\`\`\`java
new WaIcon<>()
\`\`\``;
	mdContent_361 = `\`\`\`java
new WaIcon<>(String name)
\`\`\``;
	mdContent_362 = `\`\`\`java
var icon = new WaIcon<>("star");
\`\`\``;
	mdContent_363 = `\`\`\`java
var icon = new WaIcon<>("house");
icon.setFamily("sharp-duotone");
\`\`\``;
	mdContent_364 = `\`\`\`java
var icon = new WaIcon<>();
icon.addClass("fak");
icon.addClass("fa-my-custom-icon");
\`\`\``;
}
